module.exports = __webpack_public_path__ + "static/media/qa-testing.e8b825c7.svg";